
<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row><b-col sm="12"><h4 style="text-align: center">7. DATOS DE DEPENDIENTES ECONÓMICOS</h4> </b-col></b-row>

    <b-row>
      <b-col md="12">
        <b-form-group label="¿TIENE DEPENDIENTES ECONÓMICOS?">
          <b-form-radio-group :disabled="status == 'Concluida'" v-model="depe.ninguno" >
            <b-form-radio :value="false">SI</b-form-radio>
            <b-form-radio :value="true">NO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <b-list-group sm="12" v-if="!depe.ninguno">
      <b-list-group-item v-for="(dependiente, index) in dependientes" :key="index">
        <br />
        <br />
       
        <b-row style="text-align: center">
          <b-col sm="12" >
           <h5 style="text-align: center">TIPO DE OPERACIÓN </h5>
          </b-col>      
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"              
              size="sm"
              :variant="dependiente.tipoOperacion == 'SIN CAMBIOS'? 'info' : 'outline-info'"
              @click="dependiente.tipoOperacion = 'SIN CAMBIOS', modificarTipoOperacion(dependiente._id)"
              >SIN CAMBIOS</b-button>
          </b-col>
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"
              :variant="dependiente.tipoOperacion == 'MODIFICAR'? 'success' : 'outline-success'"
              size="sm"
              @click="modificarDepe(dependiente._id)"
              >MODIFICAR</b-button>
          </b-col>
          <b-col sm="4">
           <b-button
              v-if="status !== 'Concluida'"
              variant="outline-danger"
              size="sm"
              @click="eliminaDepe(dependiente._id, index)"
              >ELIMINAR</b-button>
          </b-col>          
        </b-row>
     
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label >NOMBRE(S)</label>
              <b-form-input
              disabled
                
                v-model="dependiente.nombre"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label for="apellidop">PRIMER APELLIDO</label>
              <b-form-input
              disabled
                
                v-model="dependiente.primerApellido"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label >SEGUNDO APELLIDO</label>
              <b-form-input
                disabled
                
                v-model="dependiente.segundoApellido"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Fecha de nacimineto:">
              <datetime
              disabled
                id="egreso"
                :input-class="'form-control input'"
                v-model="dependiente.fechaNacimiento"
                type="date"
                
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label for="RFC">RFC</label>
              <b-form-input
                disabled
                
                v-model="dependiente.rfc"
               placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="RELACIÓN CON EL DECLARANTE ">
              <b-form-select
              disabled
                @change="encuentraParentescoValor(index)  "
                v-model="dependiente.parentescoRelacion.clave"
                :options="parentesco"
                text-field="valor"
                value-field="clave"
                ></b-form-select
              >
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="¿ES ESTRANJERO?">
              <b-form-radio-group  disabled v-model="dependiente.extranjero">
                <b-form-radio :value="true">SI</b-form-radio>
                <b-form-radio :value="false">NO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label for="curp">CURP</label>
              <b-form-input
              disabled
                
                v-model="dependiente.curp"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="LUGAR DONDE RESIDE ">
              <b-form-select
              disabled
                
                v-model="dependiente.lugarDondeReside"
                @change="llenaEspaciosDomicilio(index)"
                :options="residencia"
                ></b-form-select
              >
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="¿ES PROVEEDOR O CONTRATISTA DEL GOBIERNO?">
              <b-form-radio-group disabled v-model="dependiente.proveedorContratistaGobierno" >
                <b-form-radio :value="true">SI</b-form-radio>
                <b-form-radio :value="false">NO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col md="4" v-if="dependiente.proveedorContratistaGobierno === true">
            <b-form-group label="SECTOR ">
              <b-form-select
              disabled
                @change=" encuentraSector(index)"
                :options="sectorPrivado"
                text-field="valor"
                value-field="clave"
                v-model="dependiente.sector.clave"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group
              label="¿HABITA EN EL DOMICILIO DEL DECLARANTE?"            >
              <b-form-radio-group  disabled v-model="dependiente.habitaDomicilioDeclarante"  @change="llenaEspaciosDomicilio2(index)">
                <b-form-radio :value="true">SI</b-form-radio>
                <b-form-radio :value="false">NO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          </b-row>

        <b-row v-if="muestraDomicilio(index) && !depe.ninguno && mostrarTipoNacionalidad(index) === 'MÉXICO'">
          <b-col md="6">
            <b-form-group>
              <label>CALLE</label>
              <b-form-input
              disabled
                
               v-model="dependiente.domicilioMexico.calle"
                placeholder="CALLE"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Número exterior:</label>
              <b-form-input
                disabled
                v-model="dependiente.domicilioMexico.numeroExterior"
                placeholder="NUM EXTERIOR"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Número interior:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioMexico.numeroInterior"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Entidad Federativa:</label>
              <b-form-select
              disabled
                @change="encuentraEstadoValor(index)"
                v-model="dependiente.domicilioMexico.entidadFederativa.clave"
                :options="estados"
                text-field="valor"
                value-field="clave"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Municipio:</label>
              <b-form-select
                disabled
                @change=" encuentraMuniValor(index)"
                :options="cargaMunicipio(index)"
                v-model="dependiente.domicilioMexico.municipioAlcaldia.clave"
                text-field="valor"
                value-field="clave"
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Colonia o localidad:</label>
              <b-form-input
                disabled
                v-model="dependiente.domicilioMexico.coloniaLocalidad"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Código postal:</label>
              <b-form-input
                disabled
                v-model="dependiente.domicilioMexico.codigoPostal"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row
          v-if="
            muestraDomicilio(index) &&
              !depe.ninguno &&
              mostrarTipoNacionalidad(index) === 'EXTRANJERO'
          "
        >
          <b-col md="2">
            <b-form-group>
              <label>País:</label>
              <b-form-select

              disabled
                
                v-model="dependiente.domicilioExtranjero.pais"
                :options="pais"
                text-field="nombre"
                value-field="clave"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>Calle:</label>
              <b-form-input

              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.calle"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Número exterior:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.numeroExterior"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Número interior:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.numeroInterior"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label>Ciudad:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.ciudadLocalidad"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Estado Provincia:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.estadoProvincia"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Código postal:</label>
              <b-form-input
              disabled
                
                type="text"
                v-model="dependiente.domicilioExtranjero.codigoPostal"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="!depe.ninguno">
          <b-col md="4">
            <b-form-group label="Actividad laboral del dependiente:">
              <b-form-select
              disabled
                id="radios10"
                v-model="dependiente.actividadLaboral.clave"
                @input="
                  llenaEspacionsTrabajo(index), encuentraLaboralValor(index)
                "
                :name="'extranjersdfo_'"
                text-field="valor"
                value-field="clave"
                :options="actividadLaboral"
              >
                <template v-slot:first>
                  <option :value="null">Selecciona </option>
                </template></b-form-select
              >
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="!depe.ninguno && dependiente.actividadLaboral.clave === 'PUB'">
          <br />
          <br />
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <b-col md="4">
            <b-form-group label="Nivel u orden de Gobierno: ">
              <b-form-select
              disabled
                
                :options="nivelOrdenGobierno"
                v-model="
                  dependiente.actividadLaboralSectorPublico.nivelOrdenGobierno
                "
                class="mb-3"
              > <template v-slot:first>
                  <option :value="null">Selecciona </option>
                </template></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Ámbito Público: ">
              <b-form-select
              disabled
                
                :options="ambitoPublico"
                v-model="dependiente.actividadLaboralSectorPublico.ambitoPublico"
                class="mb-3"
              > <template v-slot:first>
                  <option :value="null">Selecciona </option>
                </template></b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group>
              <label for="institucion"
                >Institución/Empresa/Nombre, denominación o razón social:</label
              >
              <b-form-input
              disabled
                
                v-model="
                  dependiente.actividadLaboralSectorPublico.nombreEntePublico
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="area">Unidad administrativa/Área:</label>
              <b-form-input
              disabled
                
                v-model="dependiente.actividadLaboralSectorPublico.areaAdscripcion"
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="puesto">Puesto o cargo desempeñado:</label>
              <b-form-input
              disabled
                
                v-model="
                  dependiente.actividadLaboralSectorPublico.empleoCargoComision
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="funcion">Función principal:</label>
              <b-form-input
                
                v-model="
                  dependiente.actividadLaboralSectorPublico.funcionPrincipal
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Ingreso:">
              <datetime
                id="ingre"
                disabled
                :input-class="'form-control input'"
                v-model="dependiente.actividadLaboralSectorPublico.fechaIngreso"
                type="date" placeholder="Ingrese fecha"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label for="salario">Salario Mensual Neto:</label>
              <b-form-input

              disabled
                
                v-model="
                  dependiente.actividadLaboralSectorPublico.salarioMensualNeto
                    .valor
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <label for="moneda">Moneda:</label>
              <b-form-input
              
                v-model="
                  dependiente.actividadLaboralSectorPublico.salarioMensualNeto
                    .moneda
                "
                type="text"
                placeholder="MXN"
                value="MXN"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="
            !depe.ninguno &&
              (dependiente.actividadLaboral.clave === 'PRI' ||
                dependiente.actividadLaboral.clave === 'Otro')
          "
        >
          <br />
          <br />
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <b-col md="8">
            <b-form-group>
              <label for="institucion"
                >Institución/Empresa/Nombre, denominación o razón social:</label
              >
              <b-form-input
              disabled
                
                v-model="
                  dependiente.actividadLaboralSectorPrivadoOtro
                    .nombreEmpresaSociedadAsociacion
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="RFC">RFC:</label>
              <b-form-input
              disabled
                
                v-model="dependiente.actividadLaboralSectorPrivadoOtro.rfc"
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="puesto">Puesto o cargo desempeñado:</label>
              <b-form-input
              disabled
                
                v-model="dependiente.actividadLaboralSectorPrivadoOtro.empleoCargo"
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Ingreso:">
              <datetime
              disabled
                id="ingreso"
                :input-class="'form-control input'"
                v-model="
                  dependiente.actividadLaboralSectorPrivadoOtro.fechaIngreso
                "
                type="date"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label for="salario">Salario Mensual Neto:</label>
              <b-form-input
              disabled
                
                v-model="
                  dependiente.actividadLaboralSectorPrivadoOtro.salarioMensualNeto
                    .valor
                "
                type="text"
                placeholder="INGRESAR DATOS"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group>
              <label for="moneda">Moneda:</label>
              <b-form-input
                v-model="dependiente.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda"
                type="text"
                value="MXN"
                placeholder="MXN"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
       
      </b-list-group-item>
    </b-list-group>
    <br />

    <b-row v-if="!depe.ninguno">
      <b-col md="12">
        <b-button
         v-if="status !== 'Concluida'"
          variant="primary"
     
          @click="agregar = true, dependienteEditar=null"
          :disabled="enviando"
          >Nuevo Dependiente</b-button
        >
      </b-col>
    </b-row>

    <br />
    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label for="funcion">ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
            :disabled="status=='Concluida'"
            @change="cambiosAclaraciones = true"
            v-model="depe.aclaracionesObservaciones"
            type="text"
            placeholder="INGRESAR DATOS"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(6)" :disabled="enviando">Anterior</b-button>
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarSeccion()"
          :disabled="enviando"
        >Siguiente</b-button>
      </b-col>
    </b-row>
    <agregar-dependiente
      v-if="agregar"
      :mostrar="agregar"
      :dependienteEditar="dependienteEditar"
      @cancelar="agregar=false, dependienteEditar=null"
      @dependienteAgregado="dependienteAgregado"
    />
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import vSelect from "vue-select";
import { muni } from "../../../store/municipios";
import { paises } from "../../../store/paises";
import { monedas } from "../../../store/monedas";
import agregarDependiente from './agregarDependiente.vue';

export default {
  name:"dependientes",
  props: ["depe", "status"],
  components: {
    Datetime,
    Loader,
    agregarDependiente
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    dependientes(){
      let lista = []
      if(this.depe.dependienteEconomico.length>0){
        this.depe.dependienteEconomico.forEach(dep=>{
        //console.log(dep);
          let obj = {
            _id:dep._id,
            tipoOperacion: dep.tipoOperacion,
            nombre: dep.nombre,
            primerApellido: dep.primerApellido,
            segundoApellido: dep.segundoApellido,
            fechaNacimiento: dep.fechaNacimiento,
            rfc: dep.rfc,
            parentescoRelacion: { 
              clave: dep.parentescoRelacion.clave,
              valor: dep.parentescoRelacion.valor
               },
            extranjero: dep.extranjero,
            curp: dep.curp,
            habitaDomicilioDeclarante: dep.habitaDomicilioDeclarante,
            lugarDondeReside: dep.lugarDondeReside,
            domicilioMexico: {
              calle: dep.domicilioMexico.calle,
              numeroExterior: dep.domicilioMexico.numeroExterior,
              numeroInterior: dep.domicilioMexico.numeroInterior,
              coloniaLocalidad: dep.domicilioMexico.coloniaLocalidad,
              municipioAlcaldia: { 
                clave: dep.domicilioMexico.municipioAlcaldia.clave,
                valor: dep.domicilioMexico.municipioAlcaldia.valor
                },
              entidadFederativa: { 
                clave: dep.domicilioMexico.entidadFederativa.clave,
                valor: dep.domicilioMexico.entidadFederativa.valor
               },
              codigoPostal: dep.domicilioMexico.codigoPostal
            },
            domicilioExtranjero: {
              calle: dep.domicilioExtranjero.calle,
              numeroExterior: dep.domicilioExtranjero.numeroExterior,
              numeroInterior: dep.domicilioExtranjero.numeroInterior,
              ciudadLocalidad: dep.domicilioExtranjero.ciudadLocalidad,
              estadoProvincia: dep.domicilioExtranjero.estadoProvincia,
              pais: dep.domicilioExtranjero.pais,
              codigoPostal: dep.domicilioExtranjero.codigoPostal
            },
            actividadLaboral: { 
              clave: dep.actividadLaboral.clave,
              valor: dep.actividadLaboral.valor
             },
            actividadLaboralSectorPublico: {
              nivelOrdenGobierno: dep.actividadLaboralSectorPublico.nivelOrdenGobierno,
              ambitoPublico: dep.actividadLaboralSectorPublico.ambitoPublico,
              nombreEntePublico: dep.actividadLaboralSectorPublico,
              areaAdscripcion: dep.actividadLaboralSectorPublico.areaAdscripcion,
              empleoCargoComision: dep.actividadLaboralSectorPublico.empleoCargoComision,
              funcionPrincipal: dep.actividadLaboralSectorPublico.funcionPrincipal,
              salarioMensualNeto: { 
                valor: dep.actividadLaboralSectorPublico.salarioMensualNeto.valor,
                moneda: dep.actividadLaboralSectorPublico.salarioMensualNeto.moneda
               },
              fechaIngreso: dep.actividadLaboralSectorPublico.fechaIngreso
            },
            actividadLaboralSectorPrivadoOtro: {
              nombreEmpresaSociedadAsociacion: dep.actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion,
              rfc: dep.actividadLaboralSectorPrivadoOtro.rfc,
              empleoCargo: dep.actividadLaboralSectorPrivadoOtro.empleoCargo,
              fechaIngreso: dep.actividadLaboralSectorPrivadoOtro.fechaIngreso,
              salarioMensualNeto: { 
                valor: dep.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor,
                moneda: dep.actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda
               }
            },
            proveedorContratistaGobierno: dep.proveedorContratistaGobierno,
            sector: { 
              clave: dep.sector.clave,
              valor: dep.sector.valor
             }

          }
          lista.push(obj)
        })
      }
      return lista 

    }
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      agregar:false,
      dependienteEditar:null,
      cambios:false,
      banderaTrabaja: false,
      actividadLaboral: [
        { clave: "PUB", valor: "PÚBLICO" },
        { clave: "PRI", valor: "PRIVADO" },
        { clave: "OTRO", valor: "OTRO" },
        { clave: "NIN", valor: "NINGUNO" }
      ],
      
      parentesco: [
        { clave: "ABU", valor: "ABUELO(A)" },
        { clave: "NIE", valor: "NIETO(A)" },
        { clave: "TIOA", valor: "TIO(A)" },
        { clave: "AHI", valor: "AHIJADO(A)" },
        { clave: "NUE", valor: "NUERA" },
        { clave: "YER", valor: "YERNO" },
        { clave: "CUN", valor: "CUÑADO(A)" },
        { clave: "PAD", valor: "PADRE" },
        { clave: "HER", valor: "HERMANO(A)" },
        { clave: "PRI", valor: "PRIMO(A)" },
        { clave: "HIJ", valor: "HIJO(A)" },
        { clave: "SOB", valor: "SOBRINO(A)" },
        { clave: "MAD", valor: "MADRE" },
        { clave: "SUE", valor: "SUEGRO(A)" },
        { clave: "BISA", valor: "BISABUELO(A)" },
        { clave: "BISN", valor: "BISNIETO(A)" },
        { clave: "CONB", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CONC", valor: "CONCUÑO(A)" },
        { clave: "CONY", valor: "CÓNYUGE" },
        { clave: "TATA", valor: "TATARABUELO(A)" },
        { clave: "TATN", valor: "TATARANIETO(A)" },
        { clave: "NIN", valor: "NINGUNO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      residencia: ["MÉXICO", "EXTRANJERO", "SE DESCONOCE"],
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      banderaNacionalidad: "México",
      municipios: muni,
      pais: paises,
      pais2: [
        { clave: "MX", valor: "MÉXICO" },
        { clave: "EX", valor: "EXTRANJERO" }
      ],
      nivelOrdenGobierno: ["FEDERAL", "ESTATAL", "MUNICIPAL_ALCALDIA"],
      ambitoPublico: [
        "EJECUTIVO",
        "LEGISLATIVO",
        "JUDICIAL",
        "ORGANO_AUTONOMO"
      ],
      sectorPrivado: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "AGRICULTURA" }
      ],
      tipoMoneda: monedas,
      contador: 1
    };
  },
  methods: {
    modificarDepe(id){
      this.dependienteEditar = this.depe.dependienteEconomico.find(x => x._id == id)
      this.agregar = true;
    },
    actualizarSeccion() {
      this.enviando = true;
      axios.put(this.httpURL + "/declaraciones/V2/datosDependientes/" + this.$route.params.id +"/aclaracionesObservaciones",
          {
            ninguno:this.depe.ninguno,
            aclaracionesObservaciones: this.depe.aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          if (res.data.ok) {
            this.$notify({ group: "foo",   type: "success", duration: 2500,  speed: 1000, text: res.data.mensaje });
          }
          this.enviando = false;
          this.verSeccion(8)
        })
        .catch(error => {
          this.$notify({  group: "foo",  type: "error", duration: 2500, speed: 1000,text: "No se pudo guardar la sección." });
          this.enviando = false;
        });
    },
    dependienteAgregado(dependiente){
      this.depe.dependienteEconomico.push(dependiente)
      this.depe.ninguno=false;
      this.agregar=false;
    },
    //TODO-ATH:Modificar el tipo de operacion cuando solo es a sin cambios
    modificarTipoOperacion(idDependiente){
      this.enviando = true;
      axios.put(this.httpURL + "/declaraciones/V2/datosDependientes/" + this.$route.params.id +"/tipoOperacion/"+idDependiente,
          {
            
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          //console.log(res);
          if (res.data.ok) {
            this.$notify({ group: "foo",   type: "success", duration: 2500,  speed: 1000, text: res.data.mensaje });
          }
          this.enviando = false;
   
        })
        .catch(error => {
          this.$notify({  group: "foo",  type: "error", duration: 2500, speed: 1000,text: "No se pudo guardar la sección." });
          this.enviando = false;
        });
    },

    eliminaDepe(idDepe, index) {
      //console.log(idDepe);
        swal({
          text: "¿Está seguro en eliminar el dependiente?",
          icon: "warning",
          buttons: true,
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            axios
              .delete(this.httpURL + "/declaraciones/V2/datosDependientes/" + this.$route.params.id + "/dependienteEconomico/" +idDepe,
                { headers: { token: this.sessionToken } }
              )
              .then(res => {
              //  console.log(res);
                if (res.data.ok ) {
                  this.$notify({ group: "foo", type: "success",  duration: 2500,speed: 1000, text: res.data.mensaje    });
                  this.depe.dependienteEconomico.splice(index, 1);
                 
                }
                this.enviando = false;
              })
              .catch(error => {
                this.$notify({ group: "foo",  type: "error", duration: 2500, speed: 1000, text: "No se pudo guardar la sección."});
                this.enviando = false;
              });
          }
        });
    
    },

    cargaMunicipio(index) {
      let listaMuni = [];

      if (Number.isInteger(index)) {
        if (
          this.depe.dependienteEconomico[index].domicilioMexico
            .entidadFederativa.clave !== null
        ) {
          this.municipios.forEach(value => {
            if (
              value.claveEstado ===
              this.depe.dependienteEconomico[index].domicilioMexico
                .entidadFederativa.clave
            ) {
              listaMuni.push(value);
            }
          });
        }
      }

      return listaMuni;
    },

    llenaEspacionsTrabajo(index) {
      if (
        this.depe.dependienteEconomico[index].actividadLaboral.clave === "PUB"
      ) {
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion =
          "";

        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.empleoCargo = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.rfc = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.fechaIngreso = "";

        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda = "";
      } else if (
        this.depe.dependienteEconomico[index].actividadLaboral.clave ===
          "PRI" ||
        this.depe.dependienteEconomico[index].actividadLaboral.clave === "OTRO"
      ) {
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.nivelOrdenGobierno = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.ambitoPublico = "";

        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.nombreEntePublico = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.areaAdscripcion = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.empleoCargoComision = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.funcionPrincipal = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.salarioMensualNeto.valor = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.salarioMensualNeto.moneda = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.fechaIngreso = "";
      } else if (
        this.depe.dependienteEconomico[index].actividadLaboral.clave === "NIN"
      ) {
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.nivelOrdenGobierno = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.ambitoPublico = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.nombreEntePublico = "";

        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.areaAdscripcion = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.empleoCargoComision = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.funcionPrincipal = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.salarioMensualNeto.valor = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.salarioMensualNeto.moneda = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPublico.fechaIngreso = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.nombreEmpresaSociedadAsociacion =
          "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.empleoCargo = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.rfc = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.fechaIngreso = "";

        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.salarioMensualNeto.valor = "";
        this.depe.dependienteEconomico[
          index
        ].actividadLaboralSectorPrivadoOtro.salarioMensualNeto.moneda = "";
      }
    },

    llenaEspaciosDomicilio(index) {
      if (this.depe.dependienteEconomico[index].lugarDondeReside !== null) {
        if (
          this.depe.dependienteEconomico[index].lugarDondeReside !==
          "SE DESCONOCE"
        ) {
          this.depe.dependienteEconomico[index].domicilioMexico.calle = "";
          this.depe.dependienteEconomico[index].domicilioMexico.numeroExterior =
            "";
          this.depe.dependienteEconomico[index].domicilioMexico.numeroInterior =
            "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.coloniaLocalidad = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.municipioAlcaldia.clave = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.municipioAlcaldia.valor = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.entidadFederativa.clave = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.entidadFederativa.valor = "";

          this.depe.dependienteEconomico[index].domicilioMexico.codigoPostal =
            "";
          this.depe.dependienteEconomico[index].domicilioExtranjero.calle = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.numeroExterior = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.numeroInterior = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.ciudadLocalidad = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.estadoProvincia = "";
          this.depe.dependienteEconomico[index].domicilioExtranjero.pais = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.codigoPostal = "";
        } else {
          if (
            this.depe.dependienteEconomico[index].lugarDondeReside ===
            "EXTRANJERO"
          ) {
            this.depe.dependienteEconomico[index].domicilioMexico.calle = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.numeroExterior = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.numeroInterior = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.coloniaLocalidad = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.municipioAlcaldia.clave = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.municipioAlcaldia.valor = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.entidadFederativa.clave = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioMexico.entidadFederativa.valor = "";
            this.depe.dependienteEconomico[index].domicilioMexico.codigoPostal =
              "";
          } else {
            this.depe.dependienteEconomico[index].domicilioExtranjero.calle =
              "";
            this.depe.dependienteEconomico[
              index
            ].domicilioExtranjero.numeroExterior = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioExtranjero.numeroInterior = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioExtranjero.ciudadLocalidad = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioExtranjero.estadoProvincia = "";
            this.depe.dependienteEconomico[index].domicilioExtranjero.pais = "";
            this.depe.dependienteEconomico[
              index
            ].domicilioExtranjero.codigoPostal = "";
          }
        }
      }
    },

    llenaEspaciosDomicilio2(index) {
      if (
        this.depe.dependienteEconomico[index].habitaDomicilioDeclarante !== null
      ) {
        if (
          this.depe.dependienteEconomico[index].habitaDomicilioDeclarante ===
          true
        ) {
          this.depe.dependienteEconomico[index].domicilioMexico.calle = "";
          this.depe.dependienteEconomico[index].domicilioMexico.numeroExterior =
            "";
          this.depe.dependienteEconomico[index].domicilioMexico.numeroInterior =
            "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.coloniaLocalidad = "";

          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.municipioAlcaldia.clave = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.municipioAlcaldia.valor = "";

          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.entidadFederativa.clave = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioMexico.entidadFederativa.valor = "";

          this.depe.dependienteEconomico[index].domicilioMexico.codigoPostal =
            "";
          this.depe.dependienteEconomico[index].domicilioExtranjero.calle = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.numeroExterior = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.numeroInterior = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.ciudadLocalidad = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.estadoProvincia = "";
          this.depe.dependienteEconomico[index].domicilioExtranjero.pais = "";
          this.depe.dependienteEconomico[
            index
          ].domicilioExtranjero.codigoPostal = "";
        }
      }
    },

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },

    muestraDomicilio(index) {
      
        if (
          this.depe.dependienteEconomico[index].lugarDondeReside !== null && this.depe.dependienteEconomico[index].habitaDomicilioDeclarante !== null) {
          if (this.depe.dependienteEconomico[index].lugarDondeReside !==  "SE DESCONOCE" && this.depe.dependienteEconomico[index].habitaDomicilioDeclarante === false
          ) {
            return true;
          }
          return false;
        }
        return false;
  
    },
    mostrarTipoNacionalidad(index) {
      if (Number.isInteger(index)) {
        if (this.depe.dependienteEconomico[index].lugarDondeReside !== null) {
          if (
            this.depe.dependienteEconomico[index].lugarDondeReside === "MÉXICO"
          ) {
            return "MÉXICO";
          } else if (
            this.depe.dependienteEconomico[index].lugarDondeReside ===
            "EXTRANJERO"
          ) {
            return "EXTRANJERO";
          } else if (
            this.depe.dependienteEconomico[index].lugarDondeReside ===
            "SE DESCONOCE"
          ) {
            return "NINGUNO";
          }
        } else {
          return "NINGUNO";
        }
      } else return false;
    },

    encuentraEstadoValor(index) {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.depe.dependienteEconomico[index].domicilioMexico
            .entidadFederativa.clave
      );
      this.depe.dependienteEconomico[
        index
      ].domicilioMexico.entidadFederativa.valor = this.estados[indice].valor;
    },
    encuentraMuniValor(index) {
      let indice;
      indice = this.municipios.findIndex(
        x =>
          x.clave ===
          this.depe.dependienteEconomico[index].domicilioMexico
            .municipioAlcaldia.clave
      );
      this.depe.dependienteEconomico[
        index
      ].domicilioMexico.municipioAlcaldia.valor = this.municipios[indice].valor;
    },
    encuentraParentescoValor(index) {
      let indice;

      indice = this.parentesco.findIndex(
        x =>
          x.clave ===
          this.depe.dependienteEconomico[index].parentescoRelacion.clave
      );

      this.depe.dependienteEconomico[
        index
      ].parentescoRelacion.valor = this.parentesco[indice].valor;
    },
    encuentraLaboralValor(index) {
      if (
        this.depe.dependienteEconomico[index].actividadLaboral.clave !== null
      ) {
        if (
          this.depe.dependienteEconomico[index].actividadLaboral.clave === "PUB"
        )
          this.depe.dependienteEconomico[index].actividadLaboral.valor =
            "PÚBLICO";
        else if (
          this.depe.dependienteEconomico[index].actividadLaboral.clave === "PRI"
        )
          this.depe.dependienteEconomico[index].actividadLaboral.valor =
            "PRIVADO";
        else if (
          this.depe.dependienteEconomico[index].actividadLaboral.clave ===
          "OTRO"
        )
          this.depe.dependienteEconomico[index].actividadLaboral.valor = "OTRO";
        else if (
          this.depe.dependienteEconomico[index].actividadLaboral.clave === "NIN"
        )
          this.depe.dependienteEconomico[index].actividadLaboral.valor =
            "NINGUNO";
      }
    },

    encuentraSector(index) {
      let indice;
      indice = this.sectorPrivado.findIndex(
        x => x.clave === this.depe.dependienteEconomico[index].sector.clave
      );
      this.depe.dependienteEconomico[index].sector.valor = this.sectorPrivado[
        indice
      ].valor;
    }
  },

  created() {
    this.depe.ninguno = this.depe.ninguno ? this.depe.ninguno : false;
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
